import React from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Loader from "react-loader-spinner";
import { useState, useEffect } from "react";
import { serverApi ,parseDate } from "../../../../../global/globalFunctions";
import { PDFDocument } from "pdf-lib";
import moment from "moment";

import {
  putPreliminaryFinal,
  putDisclosureForms,
  putDisclosureProvided,
  putDateDisclosure,
  putWaiveFinalDisclosure,
  putWishToWaiveFinal,
  requestAllFormData,
  getAllFormData,
  postFormData
} from "../acknowledgement/acknowledgement.actions";

import {
  getStates,
  getFormData
} from "../../../forms/profileInformation/profileInformation.actions";


import {
  FormGroup,
  Label,
  Input,
  Collapse,
  Modal,
  ModalBody,
  Row,
  Col
} from "reactstrap";
import { isEmpty, isNumber, isUndefined, filter } from "lodash";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
}));

const AcknowledgementForm = (props) => {
  const petitionerDetails = props.petitioner;
  const respondentDetails = props.respondent;
  const courtDetails = props.court;
  const petState = !isUndefined(petitionerDetails) && filter(props.states, state => state.state_id == petitionerDetails.state);
  const resState = !isUndefined(respondentDetails) && filter(props.states, state => state.state_id == respondentDetails.state);

  const [disclosureOption, setDisclosureOption] = useState(false);
  const [setOfCompletingForm, setSetOfCompletingForm] = useState(props.isSetOfCompletingForm.isSetOfCompletingFormStatus == "0" ? 0 : props.isSetOfCompletingForm.isSetOfCompletingFormStatus == "1" ? 1 : -1);
  const [propertyType, setPropertyType] = useState(false);
  const [howDisclosureServed, setHowDisclosureServed] = useState(1);
  const [waiveForFinal, setWaiveForFinal] = useState(-1);
  const [agreedOnStatements, setAgreedOnStatements] = useState(props.spouseAgree.spouseAgreeStatus == "0" ? 0 : -1);
  const [agreeOnFinal, setAgreeOnFinal] = useState(props.spouseAgree.agreeForFinalDeclaration.agreeForFinalDeclarationStatus == "3" ? 3 : -1);
  const [show, setShow] = useState(false)
  const [activeStep, setActiveStep] = React.useState(0);

  const [waiveFinalModal, setWaiveFinalModal] = useState(false);

  const handleModalShow = () => setWaiveFinalModal(true);
  const handleModalClose = () => {
    setActiveStep(5);
    setWaiveFinalModal(false);
  }
  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
    setActiveStep(5);
  }




  useEffect(() => {
    props.getStates();
    props.getFormData({ divorce_id: window.localStorage.getItem("divorce_id") });
    props.postFormData({ divorce_id: window.localStorage.getItem("divorce_id") });
    props.getAllFormData({ divorce_id: window.localStorage.getItem("divorce_id") });
  }, []);

  async function myFunctionFL_141() {
    const existingPdfBytes = await fetch(`${serverApi}/FL-141`, {
      headers: {
        Authorization: 'BEARER ' + window.localStorage.getItem("auth_id")
      },
    }).then((res) => res.arrayBuffer());

    var bytes = new Uint8Array(existingPdfBytes);
    const pdfDoc = await PDFDocument.load(bytes, { ignoreEncryption: true, });
    const form = pdfDoc.getForm();

    if (props.petitionerCheck == 0) {
      !isUndefined(petitionerDetails) && form.getField("telephone").setText(petitionerDetails.telephone);
      !isUndefined(petitionerDetails) && form.getField("email").setText(petitionerDetails.email);
      !isUndefined(petitionerDetails) && form.getField("name").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}` + `\n` + `${petitionerDetails.streetAddress}` + `\n` + `${petitionerDetails.city}` + `,` + `${petState[0].state_name}` + ` ` + `${petitionerDetails.zip}`)

    } else {
      !isUndefined(respondentDetails) && form.getField("telephone").setText(respondentDetails.telephone);
      !isUndefined(respondentDetails) && form.getField("email").setText(respondentDetails.email);
      !isUndefined(respondentDetails) && form.getField("name").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}` + `\n` + `${respondentDetails.streetAddress}` + `\n` + `${respondentDetails.city}` + `,` + `${resState[0].state_name}` + ` ` + `${respondentDetails.zip}`)
    }

    if (props.finalOrPreliminary == 0) {
      form.getCheckBox("ch_pre").check();
      if (props.petitionerCheck == 0) {
        form.getCheckBox("ch_p").check();
        form.getCheckBox("ch_pet").check();
        form.getCheckBox("ch_petitioner").check();
        form.getCheckBox("other_p").check();
        !isUndefined(petitionerDetails) && form.getField("nameP").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}` + `\n` + `${petitionerDetails.streetAddress}` + `\n` + `${petitionerDetails.city}` + `,` + `${petState[0].state_name}` + ` ` + `${petitionerDetails.zip}`);
      }
      else {
        form.getCheckBox("ch_r").check();
        form.getCheckBox("ch_res").check();
        form.getCheckBox("ch_respondent").check();
        form.getCheckBox("other_p").check();
        !isUndefined(respondentDetails) && form.getField("nameP").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`)

      }

      if (props.howDisclosuresProvided == 1) {
        form.getCheckBox("personal").check()
      } else if (props.howDisclosuresProvided == 2) {
        form.getCheckBox("mail").check()
      } else if (props.howDisclosuresProvided == 3) {
        form.getCheckBox("ch_other").check()
      } else {
        form.getCheckBox("personal").uncheck()
        form.getCheckBox("mail").uncheck()
        form.getCheckBox("ch_other").uncheck()
      }

      !isUndefined(props.disclosuresProvidedDate) && form.getField("date").setText(parseDate(props.disclosuresProvidedDate));

      if (form.getCheckBox("ch_other").isChecked()) {
        form.getField("other_text").setText("Email");

      } else {
        form.getField("other_text").setText("");
      }

      props.wishToWaiveForFinal == 1 ? form.getCheckBox("parties").check() : form.getCheckBox("parties").uncheck();

      if (props.wishToWaiveForFinal == 1 && props.spouseAgree.spouseAgreeStatus == 1) {
        form.getCheckBox("service").check()
        form.getCheckBox("s_final").check()
        form.getCheckBox("s_income").check()
        form.getCheckBox("sameTime").check()
        props.petitionerCheck == 0 ? form.getCheckBox("s_pet").check() : form.getCheckBox("s_res").check()
      }
      else if (props.wishToWaiveForFinal == 1 && props.spouseAgree.spouseAgreeStatus == 0) {
        form.getCheckBox("service").uncheck()
        form.getCheckBox("s_final").uncheck()
        form.getCheckBox("s_income").uncheck()
        form.getCheckBox("sameTime").uncheck()
        form.getCheckBox("s_pet").uncheck()
        form.getCheckBox("s_res").uncheck()
        form.getCheckBox("parties").check()
      }
      else if (props.wishToWaiveForFinal == 0 && props.spouseAgree.spouseAgreeStatus == 1) {
        form.getCheckBox("service").uncheck()
        form.getCheckBox("s_final").uncheck()
        form.getCheckBox("s_income").uncheck()
        form.getCheckBox("sameTime").uncheck()
        form.getCheckBox("s_pet").uncheck()
        form.getCheckBox("s_res").uncheck()
        form.getCheckBox("parties").uncheck()
      }
      else {
        form.getCheckBox("service").uncheck()
        form.getCheckBox("s_final").uncheck()
        form.getCheckBox("s_income").uncheck()
        form.getCheckBox("sameTime").uncheck()
        form.getCheckBox("s_pet").uncheck()
        form.getCheckBox("s_res").uncheck()
        form.getCheckBox("parties").uncheck()
      }

    }
    else {
      form.getCheckBox("ch_final").check()


      if (props.petitionerCheck == 0) {
        form.getCheckBox("ch_p").check();
        form.getCheckBox("ch_pet").check();
        form.getCheckBox("chb_pet").check();
        form.getCheckBox("chb_otherp").check();
        !isUndefined(petitionerDetails) && form.getField("nameP").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`)
      } else {
        form.getCheckBox("ch_r").check();
        form.getCheckBox("ch_res").check();
        form.getCheckBox("chb_res").check();
        form.getCheckBox("chb_otherp").check();
        !isUndefined(respondentDetails) && form.getField("nameP").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`)
      }

      if (props.howDisclosuresProvided == 1) {
        form.getCheckBox("chb_personal").check()
      } else if (props.howDisclosuresProvided == 2) {
        form.getCheckBox("chb_mail").check()
      } else if (props.howDisclosuresProvided == 3) {
        form.getCheckBox("chb_other").check()
      } else {
        form.getCheckBox("chb_personal").uncheck()
        form.getCheckBox("chb_mail").uncheck()
        form.getCheckBox("chb_other").uncheck()
      }

      !isUndefined(props.disclosuresProvidedDate) && form.getField("dateS").setText(moment(props.disclosuresProvidedDate == "1947-01-01" ? "" : parseDate(props.disclosuresProvidedDate)));

      if (form.getCheckBox("chb_other").isChecked()) {
        form.getField("other_textS").setText("Email");
      } else {
        form.getField("other_textS").setText("");
      }

      form.getCheckBox("service").uncheck()
      form.getCheckBox("s_final").uncheck()
      form.getCheckBox("s_income").uncheck()
      form.getCheckBox("sameTime").uncheck()
      form.getCheckBox("s_pet").uncheck()
      form.getCheckBox("s_res").uncheck()

    }



    !isUndefined(courtDetails) && form.getField("address").setText(courtDetails.courtStreetAddress);
    !isUndefined(courtDetails) && form.getField("mailing").setText(courtDetails.courtMailingAddress);
    !isUndefined(courtDetails) && form.getField("city").setText(`${courtDetails.city}` + ` ` + `${courtDetails.zip}`);

    !isEmpty(courtDetails) && form.getField("branch").setText(courtDetails.branchName);
    !isUndefined(courtDetails) && form.getField("superior").setText(courtDetails.county);
    !isUndefined(petitionerDetails) && form.getField("petitioner").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
    !isUndefined(respondentDetails) && form.getField("respondent").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);
    !isUndefined(courtDetails) && form.getField("caseNumber").setText(courtDetails.caseNumber.toString());

    // form.flatten();
    const pdfBytes = await pdfDoc.save();
    const pdfDataUrl = URL.createObjectURL(
      new Blob([pdfBytes], { type: "application/pdf" })
    );
    window.open(pdfDataUrl, "_blank");
  }



  async function myFunctionFL_140() {
    const existingPdfBytes = await fetch(`${serverApi}/FL-140`, {
      headers: {
        Authorization: 'BEARER ' + window.localStorage.getItem("auth_id")
      },
    }).then((res) => res.arrayBuffer());

    var bytes = new Uint8Array(existingPdfBytes);
    const pdfDoc = await PDFDocument.load(bytes, { ignoreEncryption: true, });
    const form = pdfDoc.getForm();

    if (props.finalOrPreliminary == 0) {
      form.getCheckBox("ch_pre").check()
    } else if (props.finalOrPreliminary == 1) {
      form.getCheckBox("ch_final").check()
    } else {
      form.getCheckBox("ch_pre").uncheck()
      form.getCheckBox("ch_final").uncheck()
    }

    props.isSetOfCompletingForm.isSetOfCompletingFormStatus == 0 ? form.getCheckBox("ch_comp").check() : form.getCheckBox("ch_pro").check()
    if (form.getCheckBox("ch_pro").isChecked()) {
      if (props.isSetOfCompletingForm.setOfPropertyForms.setOfPropertyFormsStatus == 0) {
        form.getCheckBox("ch_com").check()
      } else if (props.isSetOfCompletingForm.setOfPropertyForms.setOfPropertyFormsStatus == 1) {
        form.getCheckBox("ch_sep").check()
      } else if (props.isSetOfCompletingForm.setOfPropertyForms.setOfPropertyFormsStatus == 2) {
        form.getCheckBox("ch_com").check()
        form.getCheckBox("ch_sep").check()
      } else {
        form.getCheckBox("ch_com").uncheck()
        form.getCheckBox("ch_sep").uncheck()

      }
    } else {
      form.getCheckBox("ch_sep").uncheck()
      form.getCheckBox("ch_com").uncheck()
    }


    if (props.petitionerCheck == 0) {
      !isUndefined(petitionerDetails) && form.getField("telephone").setText(petitionerDetails.telephone);
      !isUndefined(petitionerDetails) && form.getField("email").setText(petitionerDetails.email);
    } else {
      !isUndefined(respondentDetails) && form.getField("telephone").setText(respondentDetails.telephone);
      !isUndefined(respondentDetails) && form.getField("email").setText(respondentDetails.email);
    }


    if (props.petitionerCheck == 0) {
      form.getCheckBox("ch_p").check()
      form.getCheckBox("ch_income").check()
      form.getCheckBox("ch_tax").check()
      form.getCheckBox("ch_valuation").check()
      form.getCheckBox("ch_obligations").check()
      form.getCheckBox("ch_accurate").check()
      !isUndefined(petitionerDetails) && form.getField("namep").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`)
      !isUndefined(petitionerDetails) && form.getField("name").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}` + `\n` + `${petitionerDetails.streetAddress}` + `\n` + `${petitionerDetails.city}` + `,` + `${petState[0].state_name}` + ` ` + `${petitionerDetails.zip}`);
    } else {
      form.getCheckBox("ch_r").check()
      form.getCheckBox("ch_income").check()
      form.getCheckBox("ch_tax").check()
      form.getCheckBox("ch_valuation").check()
      form.getCheckBox("ch_obligations").check()
      form.getCheckBox("ch_accurate").check()
      !isUndefined(respondentDetails) && form.getField("name").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}` + `\n` + `${respondentDetails.streetAddress}` + `\n` + `${respondentDetails.city}` + `,` + `${resState[0].state_name}` + ` ` + `${respondentDetails.zip}`);
      !isUndefined(respondentDetails) && form.getField("namep").setText(`${respondentDetails.firstName}` + ` ` + ` ` + `${respondentDetails.lastName}`)

    }



    !isUndefined(courtDetails) && form.getField("address").setText(courtDetails.courtStreetAddress);
    !isUndefined(courtDetails) && form.getField("mailing").setText(courtDetails.courtMailingAddress);
    !isUndefined(courtDetails) && form.getField("city").setText(`${courtDetails.city}` + ` ` + `${courtDetails.zip}`);

    !isUndefined(courtDetails) && form.getField("branch").setText(courtDetails.branchName);
    !isUndefined(courtDetails) && form.getField("superior").setText(courtDetails.county);
    !isUndefined(petitionerDetails) && form.getField("petitioner").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
    !isUndefined(respondentDetails) && form.getField("respondent").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);
    !isUndefined(courtDetails) && form.getField("caseNumber").setText(courtDetails.caseNumber.toString());

    // form.flatten();
    const pdfBytes = await pdfDoc.save();
    const pdfDataUrl = URL.createObjectURL(
      new Blob([pdfBytes], { type: "application/pdf" })
    );
    window.open(pdfDataUrl, "_blank");
  }

  function saveByteArray(reportName, byte) {
    var blob = new Blob([byte], { type: "application/pdf" });
    var link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    var fileName = reportName;
    link.download = fileName;
    link.click();
  }

  const classes = useStyles();

  function getSteps() {
    return [
      "Please select which one you want to complete first",
      props.finalOrPreliminary == 0 || props.finalOrPreliminary == -1 ? "You have an option on which forms to use to complete your Preliminary Disclosures." : "You have an option on which forms to use to complete your Final disclosures.",
      "How will/did provide your spouse your disclosures?",
      "What date did you provide your disclosures to your spouse? If you did not do it, leave it blank and either fill it out on the form later; or come back to this interview and answer the question.",
      "You and your spouse must then complete a second set of disclosures called the Final Declarations of Disclosure. Or, you have the option to waive these if you update your Preliminary Disclosures.",
      "In order to waive the Final Declaration of Disclosure, you must state that the following is true."
    ];
  }

  const steps = getSteps();
  const handlePostFunc = () => {
    if (activeStep === 0) {
      props.putPreliminaryFinal({
        divorce_id: window.localStorage.getItem("divorce_id"),
        dividingPropertyDebt: document.getElementById("disclosureType").value,
      });
    } else if (activeStep === 1) {
      props.putDisclosureForms({
        setOfCompletingForm: document.getElementById("setsOfCompletingForm").value,
        propertyType: document.getElementById("setsOfCompletingForm").value == 1 ? document.getElementById("propertyType").value : 0,
        divorce_id: window.localStorage.getItem("divorce_id"),
      });
    } else if (activeStep === 2) {
      props.putDisclosureProvided({
        divorce_id: window.localStorage.getItem("divorce_id"),
        provideDisclosures: document.getElementById("howDisclosureServed").value
      });
    } else if (activeStep === 3) {
      props.putDateDisclosure({
        divorce_id: window.localStorage.getItem("divorce_id"),
        dissolutionDate: document.getElementById("petitionDate").value
      });
    } else if (activeStep === 4) {
      props.putWaiveFinalDisclosure({
        waiveDisclosure: document.getElementById("waiveForFinal").value,
        divorce_id: window.localStorage.getItem("divorce_id"),

      });
    } else if (activeStep === 5) {
      props.putWishToWaiveFinal({
        divorce_id: window.localStorage.getItem("divorce_id"),
        spouseAgree: document.getElementById("agreedOnStatements").value,
        waiveFinalDisclosure: document.getElementById("agreedOnStatements").value == "0" ? document.getElementById("agreeOnFinal").value : "0",
      });
    } else {
    }
  };
  const handleNext = () => {
    handlePostFunc();

    if (props.finalOrPreliminary == 1 && activeStep == 3) {
      setActiveStep((prevActiveStep) =>
        prevActiveStep = steps.length - 1
      )
    }
    else if (props.wishToWaiveForFinal == 0 && activeStep == 4) {
      handleShow();
      setActiveStep((prevActiveStep) => prevActiveStep);
    }
    else if (props.wishToWaiveForFinal == 1 && activeStep == 4) {
      handleModalShow();
      setActiveStep((prevActiveStep) => prevActiveStep);
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    if (props.finalOrPreliminary == 1 && activeStep === 6) {
      setActiveStep(3);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <div>
            <FormGroup>
              <Input
                type="select"
                name="disclosureType"
                id="disclosureType"
                defaultValue={props.finalOrPreliminary}
                onChange={(e) => setDisclosureOption(JSON.parse(e.target.value))}
              >
                <option selected value="-1">
                  -- select an option --
                </option>
                <option value={0} >Preliminary</option>
                <option value={1} >Final</option>
              </Input>
            </FormGroup>
          </div>
        );
      case 1:
        return (
          <div>
            <FormGroup>
              <Label for="setsOfCompletingForm"> Select your option: </Label>
              <Input
                type="select"
                name="setsOfCompletingForm"
                id="setsOfCompletingForm"
                defaultValue={props.isSetOfCompletingForm.isSetOfCompletingFormStatus}
                onChange={(e) => setSetOfCompletingForm(JSON.parse(e.target.value))}
              >
                <option selected value="-1">
                  -- select an option --
                </option>
                <option value={0}> Income and Expense Declaration (FL-150) and Schedule of Assets and Debts (FL-142) </option>
                <option value={1}> Income and Expense Declaration (FL-150) and Property Declaration (FL-160) </option>
              </Input>
            </FormGroup>

            <Collapse isOpen={setOfCompletingForm === 0 ? true : false} >
              <FormGroup>
                <ul>
                  <li> Income and Expense Declaration, FL-150, and </li>
                  <li> Schedule of Assets and Debts, FL-142 </li>
                </ul>
              </FormGroup>
            </Collapse>

            <Collapse isOpen={setOfCompletingForm === 1 ? true : false} >
              <FormGroup>
                <ul>
                  <li> Income and Expense Declaration, FL-150, and </li>
                  <li> Property Declaration, FL-160 </li>
                </ul>

                <Label for="propertyType"> For the Property Declaration, select which ones you will complete:</Label>
                <Input
                  type="select"
                  name="propertyType"
                  id="propertyType"
                  defaultValue={props.isSetOfCompletingForm.setOfPropertyForms.setOfPropertyFormsStatus}
                  onChange={(e) => setPropertyType(JSON.parse(e.target.value))}
                >
                  <option selected value="-1">
                    -- select an option --
                  </option>
                  <option value={0}> Community Only </option>
                  <option value={1}> Separate Only</option>
                  <option value={2}> Community and Separate </option>
                </Input>
              </FormGroup>
            </Collapse>
          </div>
        );
      case 2:
        return (
          <div>
            <FormGroup>
              <Input
                type="select"
                name="howDisclosureServed"
                id="howDisclosureServed"
                defaultValue={props.howDisclosuresProvided}
                onChange={(e) => setHowDisclosureServed(JSON.parse(e.target.value))}
              >
                <option selected value="-1">
                  -- select an option --
                </option>
                <option value={1}>Personal Service</option>
                <option value={2}>Mail</option>
                <option value={3}>Email</option>
              </Input>
            </FormGroup>
          </div>
        );
      case 3:
        return (
          <div>
            <FormGroup>
              <p style={{ backgroundColor: "yellow", height: "10%", marginLeft: "8%", marginRight: "8%", paddingLeft: "2%", paddingRight: "2%", borderRadius: "8px", textAlign: "center" }}>
                <b> Important! </b> The date must be after the Petition for Dissolution was filed.
              </p>
              <Row>
                <Col xl={4} lg={4} md={3} />
                <Col xl={4} lg={4} md={6} >
                  <Input
                    defaultValue={props.disclosuresProvidedDate == "1947-01-01" ? "" : props.disclosuresProvidedDate}
                    type="date"
                    name="petitionDate"
                    id="petitionDate"
                  />
                </Col>
                <Col xl={4} lg={4} md={3} />
              </Row>
            </FormGroup>
          </div>
        );
      case 4:
        return (
          <div>
            <FormGroup>
              <Label for="waiveForFinal"> Do you wish to waive the Final Declarations of Disclosures (not complete the forms again)? </Label>
              <Input
                type="select"
                name="waiveForFinal"
                id="waiveForFinal"
                defaultValue={props.wishToWaiveForFinal}
                onChange={(e) => setWaiveForFinal(JSON.parse(e.target.value))}
              >
                <option selected value="-1">
                  -- select an option --
                </option>
                <option value={0}> No</option>
                <option value={1}> Yes</option>
              </Input>
            </FormGroup>
          </div>
        );
      case 5:
        return (
          <div>
            <FormGroup>
              <FormGroup>
                <div style={{ marginLeft: "8%" }}>
                  <ol type="a">
                    <li>You have complied with Family Code Section 2104, and you completed and exchanged your Preliminary Declarations of Disclosure. [This is Step 2.]</li>
                    <li>You have completed and exchanged a current Income and Expense (FL-150). [Note: you would waive the second I&E as part of this waiver].</li>
                    <li>You complied with Family Law Section 2102, updating your Preliminary with the following information:
                      <ol type="i">
                        <li>Characterization of all assets and liabilities.</li>
                        <li>Valuation of all assets that are community or have a community interest.</li>
                        <li>Amounts of all community debts & obligations.</li>
                      </ol>
                    </li>
                    <li>Each of you understand that the waiver does not limit your legal disclosure obligations but rather is a statement under the penalty of perjury that you complied with these rules.</li>
                    <li>You also understand that if you do not comply with these obligations, the court (judge) will set aside your judgment.</li>
                  </ol>
                </div>
              </FormGroup>
              <FormGroup>
                <Label for="agreedOnStatements"> Do you and your spouse agree? </Label>
                <Input
                  type="select"
                  name="agreedOnStatements"
                  id="agreedOnStatements"
                  defaultValue={props.spouseAgree.spouseAgreeStatus}
                  onChange={(e) => setAgreedOnStatements(JSON.parse(e.target.value))}
                >
                  <option selected value="-1">
                    -- select an option --
                  </option>
                  <option value={0}> No</option>
                  <option value={1}> Yes</option>
                </Input>
              </FormGroup>

            </FormGroup>
            <Collapse isOpen={agreedOnStatements === 0 ? true : false}>
              <FormGroup>
                <Label for="agreeOnFinal">If you wish to waive your Final Declarations, you must agree. Your option is to complete the steps so that you can agree and waive the Final; or, you can complete the Final Declarations. Please select one. </Label>
                <Input
                  type="select"
                  name="agreeOnFinal"
                  id="agreeOnFinal"
                  defaultValue={props.spouseAgree.agreeForFinalDeclaration.agreeForFinalDeclarationStatus}
                  onChange={(e) => setAgreeOnFinal(JSON.parse(e.target.value))}
                >
                  <option selected value="-1">
                    -- select an option --
                  </option>
                  <option value={1}> We both agree to these statements </option>
                  <option value={2}> We will comply with these agreements by the time we sign these final forms.</option>
                  <option value={3}> We will need to complete our Final Declarations of Disclosure.</option>
                </Input>

                <Collapse isOpen={agreeOnFinal == "3" ? true : false} >
                  <FormGroup>
                    <p style={{ marginTop: "3%", backgroundColor: "yellow", height: "10%", paddingLeft: "8%", paddingRight: "2%", borderRadius: "8px" }}> <b>You will need to complete another set of disclosures. Please come back and complete Step 2 again to do your Final. </b></p>
                  </FormGroup>
                </Collapse>
              </FormGroup>
            </Collapse>
          </div>
        );
      default:
        return "Unknown step";
    }
  }

  return (
    <div className={classes.root}>
      {props.isFetchingAllFormData ?
        <div style={{ marginLeft: "42%", marginTop: "18%" }}>
          <Loader
            type="Puff"
            color="#00BFFF"
            height={120}
            width={120}
          />
        </div>
        :
        <div>



          <Stepper activeStep={activeStep} orientation="vertical"
            style={{

              fontStyle: "normal",
              fontFamily: "sans-serif",
              backgroundColor: "white",
              textAlign: "justify",
              textJustify: "inter-word",
              padding: "30px 70px"
            }}
          >
            {steps.map((label, index) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
                <StepContent>
                  <Typography component="div">{getStepContent(index)}</Typography>
                  <div className={classes.actionsContainer}>
                    <div>
                      <Button
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        className={classes.button}
                      >
                        Back
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleNext}
                        className={classes.button}
                      >
                        {activeStep === steps.length - 1 ? "Finish" : "Next"}
                      </Button>
                    </div>
                  </div>
                </StepContent>
              </Step>
            ))}
          </Stepper>
          {activeStep === steps.length && (
            <Paper square elevation={0} className={classes.resetContainer}>
              <Typography>All steps completed - you&apos;re finished</Typography>
              <div>
                <Button style={{ backgroundColor: "red", color: "white" }} onClick={handleReset} className={classes.button}>
                  Reset
                </Button>
                <Button style={{ backgroundColor: "#3f51b5", color: "white" }} onClick={handleBack} className={classes.button}>
                  Back
                </Button>
              </div>
            </Paper>
          )}
          <div style={{ display: "flex", float: "right" }}>
            <Button
              style={{ marginLeft: "2px" }}
              variant="contained"
              color="primary"
              onClick={myFunctionFL_140}
            >
              Print FL-140
            </Button>
            <Button
              style={{ marginLeft: "2px" }}
              variant="contained"
              color="primary"
              onClick={myFunctionFL_141}
            >
              Print FL-141
            </Button>
          </div>
        </div>}
      <Modal isOpen={show} style={{ marginTop: "300px", marginLeft: "46%" }}>
        <ModalBody>You will need to complete another set of disclosures. Please come back and complete Step 2 again to do your Final.</ModalBody>
        <Button
          style={{ width: "", color: "black", backgroundColor: "yellow" }}
          onClick={handleClose}
        >
          <b>Close</b>
        </Button>
      </Modal>

      {/* SECODN MODAL */}

      <Modal isOpen={waiveFinalModal} style={{ marginTop: "300px", marginLeft: "46%" }}>
        <ModalBody>When waiving the Final, you must file your FL-141 with your FL-144. The questionnaire for the FL-144 is in Step 4. However, it only requires signatures. You can wait to file both the FL-141 and FL-144 with your Judgment Packet</ModalBody>
        <Button
          style={{ width: "", color: "black", backgroundColor: "yellow" }}
          onClick={handleModalClose}
        >
          <b>Close</b>
        </Button>
      </Modal>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {

    getAllFormData: (data) => dispatch(getAllFormData(data)),
    postFormData: (data) => dispatch(postFormData(data)),
    putPreliminaryFinal: (data) => dispatch(putPreliminaryFinal(data)),
    putDisclosureForms: (data) => dispatch(putDisclosureForms(data)),
    putDisclosureProvided: (data) => dispatch(putDisclosureProvided(data)),
    putDateDisclosure: (data) => dispatch(putDateDisclosure(data)),
    putWaiveFinalDisclosure: (data) => dispatch(putWaiveFinalDisclosure(data)),
    putWishToWaiveFinal: (data) => dispatch(putWishToWaiveFinal(data)),
    requestAllFormData: () => dispatch(requestAllFormData()),
    getStates: () => dispatch(getStates()),
    getFormData: (data) => dispatch(getFormData(data))
  };
};
const mapStateToProps = (state, ownProps) => ({
  finalOrPreliminary: state.acknowledgementReducer.finalOrPreliminary,
  isSetOfCompletingForm: state.acknowledgementReducer.isSetOfCompletingForm,
  howDisclosuresProvided: state.acknowledgementReducer.howDisclosuresProvided,
  wishToWaiveForFinal: state.acknowledgementReducer.wishToWaiveForFinal,
  spouseAgree: state.acknowledgementReducer.spouseAgree,
  isFetchingAllFormData: state.acknowledgementReducer.isFetchingAllFormData,
  disclosuresProvidedDate: state.acknowledgementReducer.disclosuresProvidedDate,
  petitioner: state.ProfileInformationReducer.petitionerDetails,
  respondent: state.ProfileInformationReducer.respondentDetails,
  states: state.ProfileInformationReducer.states,
  court: state.ProfileInformationReducer.court,
  petitionerCheck: state.ProfileInformationReducer.petitionerCheck,

});

export default connect(mapStateToProps, mapDispatchToProps)(AcknowledgementForm);
